export class ProductModel {
    productName: string;
    dcmCode: string;
    isChecked = false;
    fan: any = [];
    ctn: any = [];
    selectedFan = 'Select';
    selectedCtn = 'Select';
    clientId: string;
    isHidden = false;
    totalLicenses: string;
    totalLicensesInUse: string;
    totalLicensesAvailable: string;
    ctnMapObject: any;
    licensegroupName: string;
    isDisabled = false;
}
